import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-describedby", "aria-invalid"]
const _hoisted_2 = ["aria-checked", "onClick"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["id", "innerHTML"]

import { computed, useId, watch } from 'vue';
import IconCheck from '@/components/inputs/IconCheck.vue';

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'RadioButtons',
  props: /*@__PURE__*/_mergeModels({
    options: { default: () => ([
    { label: 'Ja', value: true },
    { label: 'Nein', value: false },
  ]) },
    isRequired: { type: Boolean, default: false }
  }, {
    "modelValue": {},
    "modelModifiers": {},
    "error": {},
    "errorModifiers": {},
  }),
  emits: ["update:modelValue", "update:error"],
  setup(__props: any) {

const modelValue = _useModel<unknown>(__props, "modelValue");
// eslint-disable-next-line no-undef
const error = _useModel<string | string[]>(__props, 'error');

// eslint-disable-next-line no-undef
const props = __props;

const uniqId = `radio-button-${useId()}`;
const hasError = computed(() => (error.value ? error.value.length > 0 : false));

const errorMessage = computed(() => {
  if (hasError.value) {
    return Array.isArray(props.error)
      ? props.error[0]
      : props.error;
  }

  return '';
});

watch(() => modelValue.value, () => {
  error.value = undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", {
    class: _normalizeClass(["app-radio-button", {
      invalid: hasError.value,
    }]),
    "aria-describedby": hasError.value ? `${uniqId}-error` : undefined,
    "aria-invalid": hasError.value ? 'true' : undefined
  }, [
    _createElementVNode("legend", {
      id: uniqId,
      class: "app-radio-button__label"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", {
      class: "app-radio-button__options",
      role: "radiogroup",
      "aria-labelledby": uniqId
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock("button", {
          key: `${option.value}`,
          type: "button",
          role: "radio",
          tabindex: "0",
          "aria-checked": modelValue.value === option.value ? 'true' : 'false',
          class: _normalizeClass({
          option: true,
          selected: modelValue.value === option.value,
        }),
          onClick: ($event: any) => (modelValue.value = option.value)
        }, [
          _createElementVNode("span", null, [
            (modelValue.value === option.value)
              ? (_openBlock(), _createBlock(IconCheck, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", {
            class: "option__label",
            innerHTML: option.label
          }, null, 8, _hoisted_3)
        ], 10, _hoisted_2))
      }), 128))
    ]),
    (hasError.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: `${uniqId}-error`,
          class: "app-radio-button__error",
          innerHTML: errorMessage.value
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})